module.exports = __webpack_public_path__ + "862b1db441764a562e94b25d2576fca5.jpg";